import Axios from 'axios'
import React, { useMemo, useState } from 'react'
import MainItem from './components/MainItem';
import UserPointRank from './components/UserPointRank';
import UserPointList from './components/UserPointList';
import dayjs from 'dayjs';

const Point_main = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const [mainItem, setMainItem] = useState([]);
  const [userPoints, setUserPoints] = useState(0);
  const [userBuyTotal, setUserBuyTotal] = useState(0);

  const basicID = window.sessionStorage.getItem('basicID');
  const basicPermission = window.sessionStorage.getItem('basicPermission');

  useMemo(()=>{

    let Mount = true;

    const pointDataHandler = async ()=>{
      await Axios.get('/api/Point_store/pointData')
      .then((res)=>{
        if(Mount){
          setMainItem(res.data);
        }
      })
    };
    pointDataHandler();

    // 사용자 포인트 데이터 가져오기
    const userPointData = async ()=>{
      await Axios.get('/api/Point_store/userpoint', {
        params: { userID: basicID }
      })
      .then((res)=>{
        if(Mount){
          const point = res.data[0].POINT;
          setUserPoints(point);
        }
      })
    };
    userPointData();

    // 사용자 상품 총 구매 수량
    const userTotalBuy = async ()=>{
      await Axios.get('/api/Point_store/buytotal', {
        params: { userID: basicID }
      })
      .then((res)=>{
        if(Mount){
          setUserBuyTotal(res.data[0].Count);
        }
      })
    };
    userTotalBuy();
        
    return ()=>{
      Mount = false;
    }
  }, [])
  
  return (
    <div className='text-sm'>
      {
        mainItem.length ?
        <div className='flex flex-col w-full justify-center items-center p-3 gap-3'>
          
          {/* 유저 정보 */}
          <div className='flex flex-col justify-center items-center w-full max-w-screen-xl'>
            <UserPointRank data={mainItem} point={userPoints} setUserPoints={setUserPoints} userBuyTotal={userBuyTotal} setUserBuyTotal={setUserBuyTotal}/>
          </div>

          {/* 유저 포인트 정보 리스트 */}
          <div className='flex flex-col justify-center items-center w-full max-w-screen-xl'>
            <UserPointList data={mainItem} point={userPoints} setUserPoints={setUserPoints}/>
          </div>
          
          {/* 언더라인 */}
          <div className='border-t-[1px] my-3 border-[#3E3E3E] w-full' />

          {/* 메인 아이템 */}
          <div className='flex flex-col justify-center items-center w-full max-w-screen-xl'>
            <MainItem data={mainItem} point={userPoints} setUserPoints={setUserPoints} userBuyTotal={userBuyTotal} setUserBuyTotal={setUserBuyTotal} />
          </div>

          {/* 언더라인 */}
          <div className='border-t-[1px] my-3 border-[#3E3E3E] w-full'></div>


          {/* 하단 알림 */}
          <div className='flex gap-2 max-w-screen-xl p-3 bg-[#1E1E1E] rounded-md w-full'>
            <p>📢</p>
            <div>
              {/* <p>포인트 상점의 존재 여부는 이용자들의 동기부여입니다 사이트를 이용할 때 마다 적립되는 포인트로 간단하게 이용할 수 있는 재미들이 존재하며, 빠짐없이 등록해야 할 택배/퀵, 고객등록은 더 많은 포인트가 적립됩니다.</p> */}
              <p className='text-gray-300'>포인트 상점은 이용자들의 참여율 및 동기부여를 위해 제작되었습다 사이트를 이용할 때 마다 적립되는 포인트로 간단하게 이용할 수 있는 재미들이 존재하며, 빠짐없이 등록해야 할 택배/퀵, 고객등록은 더 많은 포인트가 적립됩니다. 이로인한 데이터 정확도 및 참여율이 20% 이상 향상되었습니다</p>
              <p className='text-yellow-500/80'>관리자 및 어떠한 사용자도 포인트를 임의로 조작하거나 제거할 수 없습니다, 안심하고 공정하게 재미로 이용하시기 바랍니다</p>
            </div>
          </div>

        </div>
        :
        <div className='flex flex-col items-center p-3 gap-3'>
          <p className='mt-10 text-xl tracking-wide'>판매중인 상품이 없습니다.</p>
        </div>
      }
    </div>
  )
}

export default Point_main